import React from "react"
import "../../css/ToggleSwitch.css"

interface ToggleSwitchProps {
  isOn: boolean
  handleToggle: () => void
  onLabel?: string
  offLabel?: string
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  isOn,
  handleToggle,
  onLabel = "On",
  offLabel = "Off",
}) => {
  return (
    <div className='toggle-container'>
      <span className='label'>{isOn ? onLabel : offLabel}</span>
      <label className='switch'>
        <input type='checkbox' checked={isOn} onChange={handleToggle} />
        <span className='slider' />
      </label>
    </div>
  )
}

export default ToggleSwitch
